import { ZZ_PEAK_SCHEDULE } from './zzHelpers';
import './styles/peak-hours.css';

/* ═════════════════════════════════════════════════════════
   PEAK / OFF-PEAK SCHEDULE

   Every price on the site depends on which window a booking falls
   in, but the schedule was only ever stated in FAQ prose — so a
   member comparing tiers had to read a paragraph to work out what
   they'd be charged. This is the same information as a table they
   can scan in a couple of seconds.

   The times come from ZZ_PEAK_SCHEDULE, derived from the same
   ZZ_OFF_PEAK_BOUNDS the billing math uses, so what's advertised
   can't drift from what's charged.
   ═════════════════════════════════════════════════════════ */
export const SPeakHours = ({ heading = true }) => {
  const rows = ZZ_PEAK_SCHEDULE();
  return (
    <div className="peak-hours">
      {heading &&
        <div className="ph-head">
          <span className="eyebrow eyebrow--accent">peak &amp; off-peak</span>
          {/* h2, not h3: the only page that renders this heading is /pricing,
              where the preceding level is the page h1 — an h3 here skipped a
              level, which the heading-order test correctly caught. */}
          <h2>when you come changes what you pay.</h2>
          <p>
            a credit is R100 either way — off-peak it buys thirty minutes, peak it buys
            fifteen. private rooms are R1,000 an hour off-peak, R2,000 peak,
            payable in credits (10 and 20 an hour), by card, or a mix of both.
          </p>
        </div>
      }
      <div className="ph-table" role="table" aria-label="peak and off-peak hours">
        <div className="ph-row ph-row--head" role="row">
          <span role="columnheader">day</span>
          <span role="columnheader">off-peak</span>
          <span role="columnheader">peak</span>
        </div>
        {rows.map((r) =>
          <div key={r.label} className="ph-row" role="row">
            <span className="ph-day" role="cell">{r.label}</span>
            <span className="ph-off" role="cell">{r.offPeak}</span>
            <span className={'ph-peak' + (r.allOffPeak ? ' ph-peak--none' : '')} role="cell">
              {r.peak}
            </span>
          </div>
        )}
      </div>
      <p className="ph-note">
        all times sast. a booking that starts in one window and ends in the other is
        charged pro rata — the off-peak minutes at the off-peak rate, the peak minutes
        at the peak rate.
      </p>
    </div>
  );
};
